import { render, staticRenderFns } from "./ruleDia.vue?vue&type=template&id=5eb4358e&scoped=true&"
import script from "./ruleDia.vue?vue&type=script&lang=js&"
export * from "./ruleDia.vue?vue&type=script&lang=js&"
import style0 from "./ruleDia.vue?vue&type=style&index=0&id=5eb4358e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb4358e",
  null
  
)

export default component.exports